const SHOWN_COOKIE_CODE = "additionalProductShown";

export let additionalProductMixin = {
	data() {
		return {
			additionalProductList: false,
			alreadyShown: false
		}
	},
	computed: {},
	methods: {
		/**
		 * Инициализация. Собирает текущие данные для вывода доп. товаров к корзине
		 */
		__initAdditionalProductData() {
			if (this.isShownAdditionalProduct()) {
				this.setVisiblePopup("PopupAdditionalProduct", false);
				return;
			}

			this.$request
				.setModeModule()
				.setAction("citrus:restsale.api.additionalProduct.getList")
				.setData({})
				.send()
				.then((response) => {
					this.additionalProductList = response;
					if (this.additionalProductList.length > 0) {
						this.saveShownAdditionalProduct();
						this.setVisiblePopup("PopupAdditionalProduct", true, {
							productList: this.additionalProductList
						});
					} else {
						this.setVisiblePopup("PopupAdditionalProduct", false);
					}
				}, (error) => {
					this.additionalProductList = [];
					this.setVisiblePopup("PopupAdditionalProduct", false);
				});
		},
		saveShownAdditionalProduct() {
			BX.setCookie(SHOWN_COOKIE_CODE, 1, {path: BX.message("SITE_DIR")});
		},
		isShownAdditionalProduct() {
			return !!BX.getCookie(SHOWN_COOKIE_CODE);
		}
	}
}

export default additionalProductMixin;